const LICENCE_TYPES = [
    {
        name: "manage_cms",
        title: "Manage CMS",
        image: "icon-manage-cms.svg",
        licenceKey: ["manage_cms"]
    },
    {
        name: "notify",
        title: "Notify CRM",
        image: "icon-manage-crm.svg",
        description: "Mapsted Notify",
    },
    {
        name: "analytics",
        image: "icon-analytics.svg",
        title: "Analytics",
        licenceKey: ["analytics"],
        description:
        "Valuable intelligence <br />gleaned from your own <br />visitors' trends, patterns <br />and preferences",
    },
    {
        name: "sdk_licence",
        image: "icon-sdk.svg",
        title: "SDK",
        licenceKey: ["sdk_licence"],
        description:
        "‘Plug and Play’ <br />Software Development Kit <br />providing hardware-free <br />handheld Indoor Navigation <br />to power YOUR app",
    },
    {
        name: "ad_manager",
        image: "icon-ad-manager.svg",
        title: "Ad Manager",
        licenceKey: ["ad_manager"],
        description: "Ad Manager for Brand and Agency",
    },
    {
        name: "studio",
        title: "Mapsted Studio",
        description: "Mapsted Studio",
        image: "icon-mapsted-studio.svg", // Example image
        licenceKey: ["studio"],
    },
    {
        name: "studio_internal",
        title: "Mapsted Studio Internal",
        description: "Mapsted Studio Internal",
        image: "icon-mapsted-studio-internal.svg", // Example image
        licenceKey: ["studio_internal"],
    },
    {
        name: "calibrator",
        title: "Calibrator",
        description: "Calibrator",
        image: "icon-calibrator.svg", // Example image
        licenceKey: ["calibrator"],
    },
    {
        name: "shopping_mall",
        title: "Shopping Mall",
        description: "Shopping Mall",
        image: "icon-shopping-mall.svg", // Example image
        licenceKey: ["shopping_mall"]
    },
    {
        name: "asset",
        title: "Mapsted Asset Tracking",
        description: "Mapsted Asset Tracking",
        image: "icon-mapsted-asset-tracking.svg", // Example image
        licenceKey: ["asset"],
    },
    {
        name: "sales",
        title: "Sales",
        description: "Sales",
        image: "icon-sales.svg", // Example image
        licenceKey: ["sales"],
    },
    {
        name: "ad_manager_brand",
        title: "Ad Manager for Brand",
        description: "Ad Manager for Brand",
        image: "icon-ads-manager-for-brand.svg", // Example image
        licenceKey: ["ad_manager_brand"],
    },
    {
        name: "ad_manager_agency",
        title: "Ad Manager for Agency",
        description: "Ad Manager for Agency",
        image: "icon-ad-manager-for-agency.svg", // Example image
        licenceKey: ["ad_manager_agency"],
    },
    {
        name: "ops_internal",
        title: "Mapsted Ops Internal",
        description: "Mapsted Ops Internal",
        image: "icon-mapsted-ops-internal.svg", // Example image
        licenceKey: ["ops_internal"],
    },
    {
        name: "tweaks",
        title: "Tweaks",
        description: "Tweaks",
        image: "icon-tweaks.svg", // Example image
        licenceKey: ["tweaks"],
    },
    {
        name: "iot",
        title: "IoT",
        description: "Internet of Things",
        image: "icon-iot.svg", // Example image
        licenceKey: ["iot"],
    }
];

export default LICENCE_TYPES;
